/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagBIcon16Solid = forwardRef('FlagBIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 10.625c1.35-.573 2.66-.49 4.021.253 2.132 1.163 4.326 1.163 6.458 0A1 1 0 0 0 15 10V2c0-.745-.825-1.235-1.479-.878-1.535.837-3.007.837-4.542 0C6.955.018 4.866-.042 2.82.966A1.48 1.48 0 0 0 2 2.296V15a1 1 0 1 0 2 0v-4.375Z" })));
});
